import { useFetch, type EndpointsGET } from "data/api/useFetch"
import { useRouter } from "next/router"

export type { DatasetsListItem } from "@tokenterminal/tt-analytics-api-types/dist/api/lists"

const endpoint: EndpointsGET = "/v3/internal/lists/datasets"

interface Options {
  suspense?: boolean
  shouldFetch?: boolean
}

const defaults: Options = {}

export const useDatasetsList = ({
  suspense = true,
  shouldFetch = true,
}: Options = defaults) => {
  const { data } = useFetch("/v3/internal/lists/datasets")

  if (!data.find((d) => d.slug === "fundraises")) {
    data.push({
      name: "Fundraises",
      description:
        "Key statistics for recent financing rounds in the crypto space.",
      slug: "fundraises",
      is_new: false,
    })
  }

  return data
}

const fallback = { slug: null }

export const useDatasetParams = () => {
  const {
    query: { martSlug },
  } = useRouter()

  if (typeof martSlug !== "string") {
    return fallback
  }

  return {
    slug: martSlug,
  }
}
